import React from "react";
import TableRow from "./TableRow";

function Table({ solutions, isPendingRequest}) {
  return (
    <table className={isPendingRequest ? "table-collapse table-pending-request" : "table-collapse"}>
      <thead className="table-header">
        <tr>
          <th>Решение</th>
          <th>Общая информация</th>
          <th>Соединение I</th>
          <th>Соединение II</th>
          {/* <th>Подробнее</th> */}
        </tr>
      </thead>
      <tbody>
        {solutions
          ? solutions.map((el, ind) => {
              return <TableRow key={ind} item={el} />;
            })
          : null}
      </tbody>
    </table>
  );
}

export default Table;
